import { useOrderMovements } from '@api/useOrderMovements'
import { Drawer } from 'antd'
import { memo, type PropsWithChildren, useCallback, useEffect, useReducer, useState } from 'react'
import {
  EbolMatchingContext,
  reducer,
  useCreateEbolMatchingContext,
  ViewBolArgs,
  type EbolMatchingContextType,
} from './EbolMatchingContext'
import { EbolDrawer } from './Components/EbolDrawer'

/**
 * Auto-selects a BOL if theres only one on the order movement.
 * in practice, this lets us pop the drawer open with only an order id
 */
const useAutoSelectBol = ({ selectedBolId, selectedOrderId, viewBol }: EbolMatchingContextType) => {
  const { useOrderMovementDetailQuery } = useOrderMovements()
  const { data: orderDetail } = useOrderMovementDetailQuery(selectedOrderId)
  useEffect(() => {
    if (!selectedBolId && orderDetail?.bols?.length === 1) {
      viewBol({ bolId: orderDetail.bols[0].key })
    }
  }, [orderDetail?.bols, selectedBolId, viewBol])
}

const _EbolMatchingProvider = ({ children }: PropsWithChildren) => {
  const ctx = useCreateEbolMatchingContext()

  useAutoSelectBol(ctx)
  return (
    <EbolMatchingContext.Provider value={ctx}>
      <EbolDrawer />
      {children}
    </EbolMatchingContext.Provider>
  )
}

export const EbolMatchingProvider = memo(_EbolMatchingProvider)
